import { render, staticRenderFns } from "./DealerPhone.vue?vue&type=template&id=1c3f393e&scoped=true&"
import script from "./DealerPhone.vue?vue&type=script&lang=js&"
export * from "./DealerPhone.vue?vue&type=script&lang=js&"
import style0 from "./DealerPhone.vue?vue&type=style&index=0&id=1c3f393e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3f393e",
  null
  
)

export default component.exports